import Button from "@mui/material/Button";
import { ComponentsContent } from "app/common/NumberCard/NumberCardContent";
import * as React from "react";
import "./index.scss";

export default function Retry() {
  const retryhandler = () => {
    sessionStorage.setItem("authCount", "0");
    window.location.reload();
  };

  const supportHandler = () => {
    sessionStorage.setItem("authCount", "0");
    window.open(ComponentsContent.Home.contactDigits, "_blank");
  };

  return (
    <React.Fragment>
      <div className="retry-container">
        <span className="retry-header">Server Busy</span>
        <span className="retry-message">
          We are unable to get your account details right now. Please wait a
          moment and try again. If the problem persists, please contact care.
        </span>
        <div className="retry-actions">
          <Button
            variant="contained"
            size="medium"
            className="retry-supportBtn"
            onClick={supportHandler}
            style={{
              border: 0,
              boxShadow: "none",
              borderRadius: 0,
              width: "200px",
              height: "50px",
            }}
          >
            Contact Care
          </Button>
          <Button
            variant="contained"
            size="medium"
            className="retry-btn"
            onClick={retryhandler}
            style={{
              border: 0,
              boxShadow: "none",
              borderRadius: 0,
              width: "200px",
              height: "50px",
            }}
          >
            Retry
          </Button>
        </div>
      </div>
    </React.Fragment>
  );
}
